import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { ReportUser } from 'src/app/models/user';


@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit {
  

  @Input() index:any;
  @Input() users:any;
  @Input() placeHolder:any;
  @Output() selectedValue = new EventEmitter;
 
  public userServerSideFilteringCtrl: UntypedFormControl = new UntypedFormControl();

   /** indicate search operation is in progress */
   public searching: boolean = false;

   /** list of banks filtered after simulating server side search */
 public filteredServerSideUsers: ReplaySubject<ReportUser[]> = new ReplaySubject<ReportUser[]>(1);

 /** Subject that emits when the component has been destroyed. */
 protected _onDestroy = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.userServerSideFilteringCtrl.valueChanges
    .pipe(
      filter((search) => !!search),
      tap(() => (this.searching = true)),
      takeUntil(this._onDestroy),
      debounceTime(200),
      map((search) => {
        if (!this.users) {
          return [];
        }

        // simulate server fetching and filtering data
        return this.users.filter(
         (user:any) => user.user_fullname.toLowerCase().indexOf(search.toLowerCase()) > -1
        );
      }),
      delay(500)
     
    )
    .subscribe(
      (filteredUsers) => {
        this.searching = false;
        this.filteredServerSideUsers.next(filteredUsers);
      },
      (error) => {
        // no errors in our simulated example
        this.searching = false;
        // handle error...
      }
    );

  }

  filterCondition(event:any){
    this.selectedValue.emit(event);
  }

}
